var playlistEditBase = '/playlists/:playlistId/edit';
export var DEFAULT_EDIT_PLAYLIST_ROUTES = {
  singlePlaylistDetails: playlistEditBase,
  singlePlaylistContent: "".concat(playlistEditBase, "/content"),
  singlePlaylistContentPreview: "".concat(playlistEditBase, "/content/preview"),
  singlePlaylistAccess: "".concat(playlistEditBase, "/access"),
  singlePlaylistShare: "".concat(playlistEditBase, "/share"),
  singlePlaylistAnalytics: "".concat(playlistEditBase, "/analytics")
};